import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import Main from "../../components/main";
import MarketingPoints from "./sections/marketingPoints";
import HowItWorks from "./sections/howItWorks";
import TwitterQuotes from "./sections/twitterQuotes";
import { authActions } from "../../../core/auth";
import SaleBanner from "./sections/saleBanner";
import SecondBanner from "../../components/secondBanner";

const Home = ({ premium, loggedIn, signInWithGoogle, user }) => (
  <div>
    <Helmet>
      <title>Ghast.io: Optimize Your Connection For Minecraft PvP</title>
      <meta
        name="description"
        content="Use Ghast.io to give you an edge in Minecraft PvP, it works by changing your computers connection settings to the perfect values for Minecraft PvP."
      />
    </Helmet>
    {/* <SaleBanner
      loggedIn={loggedIn}
      premium={premium}
      signInWithGoogle={signInWithGoogle}
    /> */}
    <Main>
      <MarketingPoints />
    </Main>
    <HowItWorks />
    <Main>
      <TwitterQuotes />
    </Main>
    {/* <FAQ /> */}
    <Main>
      <SecondBanner
        premium={premium}
        loggedIn={loggedIn}
        signInWithGoogle={signInWithGoogle}
        user={user}
      />
    </Main>
  </div>
);

const mapStateToProps = (state) => ({
  loggedIn: state.auth.authenticated,
  premium: state.premium,
  user: state.user,
});

const mapDispatchToProps = {
  ...authActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/index.js
 **/